var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"fill":_vm._secondaryfill}},[_c('path',{attrs:{"d":"M29,1H3A2,2,0,0,0,1,3V29a2,2,0,0,0,2,2H29a2,2,0,0,0,2-2V3A2,2,0,0,0,29,1Z","fill":_vm.fill}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }